<template>
  <div class="material-analysis-preview">
    <el-tabs class="tabs" v-model="activeName">
      <el-tab-pane v-if="type === ANALYSIS_TYPE.SEGMENT" label="片段识别" name="1"></el-tab-pane>
      <el-tab-pane v-if="type === ANALYSIS_TYPE.TOP_MATERIAL" label="爆款拆解" name="1"></el-tab-pane>
    </el-tabs>
    <transition name="el-fade-in-linear" mode="out-in">
      <div class="state-container loading" v-if="analysisResult.taskStatus > -1 && analysisResult.taskStatus !== 3">
        <i class="el-icon-loading"></i>
        <p v-if="type === ANALYSIS_TYPE.SEGMENT">素材正在识别中，预计需要3-5分钟...</p>
        <p v-if="type === ANALYSIS_TYPE.TOP_MATERIAL">素材正在拆解中，预计需要3-5分钟...</p>
        <el-button type="text" @click="onRefresh">刷新</el-button>
      </div>
      <el-empty v-else-if="!analysisResult.taskStatus" :description="`请在左侧选择素材进行${title}`"></el-empty>
      <div class="content" v-else-if="analysisResult.taskResult" key="content">
        <div class="info">
          <el-card class="card" shadow="never">
            <h4>片段识别逻辑</h4>
            <p class="tips">{{ analysisResult.taskResult.analysis_logic }}</p>
          </el-card>
        </div>
        <div class="list-count">识别片段（{{ analysisResult.taskResult.slices.length }}）</div>
        <div class="analysis-list">
          <div
            class="clip-item"
            @click="onClipSelect(item)"
            :class="item.checked && 'checked'"
            v-for="item in analysisResult.taskResult.slices"
            :key="item.image_id"
          >
            <div class="video-desc">
              <div class="">
                <span :class="item.checked && 'icon-checked'" class="check-icon el-icon-success"></span>
                <span class="desc">{{ item.content_title }}</span>
              </div>
              <span class="time-range">{{ item.timestamp }}</span>
            </div>
            <video width="100%" :src="item.image_url" controls></video>
            <template v-if="type === ANALYSIS_TYPE.SEGMENT">
              <div class="extra-info visual-core">
                <h5>画面描述</h5>
                <p>{{ item.screen_description }}</p>
              </div>
              <div class="extra-info visual-focus">
                <h5>叙事重点</h5>
                <p>{{ item.content_narrative_focus }}</p>
              </div>
            </template>

            <template v-if="type === ANALYSIS_TYPE.TOP_MATERIAL">
              <div class="extra-info visual-core">
                <h5>内容策略</h5>
                <p>{{ item.content_strategy }}</p>
              </div>
              <div class="extra-info visual-focus">
                <h5>爆点情节</h5>
                <p>{{ item.popular_point }}</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { ANALYSIS_TYPE } from '../../const'
// eslint-disable-next-line
const props = defineProps({
  info: {
    type: Object,
    default: () => {}
  },
  type: [Number]
})
// eslint-disable-next-line
const emits = defineEmits(['select', 'get-update'])

const activeName = ref('1')
const title = computed(() => {
  switch (props.type) {
    case ANALYSIS_TYPE.SEGMENT:
      return '片段识别'
    case ANALYSIS_TYPE.TOP_MATERIAL:
      return '爆款拆解'
    default:
      return ''
  }
})
const analysisResult = computed(() => props.info.analysisResult)

function onClipSelect(item) {
  emits('select', item)
}

function onRefresh() {
  emits('get-update')
}
</script>

<style scoped lang="scss">
.material-analysis-preview {
  border: 1px solid #eee;
  border-radius: 4px;
  margin-left: 6px;

  ::v-deep .tabs {
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__nav {
      width: 100%;
    }
    .el-tabs__item {
      text-align: center;
      width: 100%;
      padding: 0;
      &.is-active {
        background: #f7fbff;
      }
    }
  }

  .state-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 506px;
    color: #606266;
  }

  ::v-deep .el-empty {
    height: 506px;
  }

  .content {
    padding: 10px 10px 0;
    height: 506px;
    overflow: auto;

    ::v-deep .card {
      background: #eff4ff;
      h4 {
        color: #1547e6;
      }
      .tips {
        color: #3152c0;
      }
      .el-card__body {
        padding: 10px 15px;
      }

      .tips {
        margin-top: 6px;
        font-size: 12px;
      }
    }

    .list-count {
      line-height: 32px;
    }

    .analysis-list {
      .clip-item {
        border: 2px solid #ebeef5;
        border-radius: 8px;
        padding: 10px;
        margin-bottom: 10px;
        cursor: pointer;

        &.checked {
          border-color: #1547e6;
        }

        video {
          font-size: 0;
          border-radius: 8px;
        }

        .video-desc {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          padding-bottom: 4px;

          .desc {
            color: #333;
            font-weight: 700;
            font-size: 14px;
          }

          .check-icon {
            font-size: 16px;
            margin-right: 12px;
            opacity: 0.3;
            &.icon-checked {
              color: #1547e6;
              opacity: 1;
            }
          }
        }

        .extra-info {
          margin-top: 10px;
          padding: 8px 10px;
          background: #eff6ff;
          color: #1547e6;
          border-radius: 8px;
          h5 {
            font-size: 14px;
            font-weight: 700;
          }
          p {
            font-size: 12px;
          }

          &.visual-focus {
            color: #ca3500;
            background: #fff7ed;
          }
        }
      }
    }
  }
}
</style>
